<template>
    <Breadcrumbs main="Site Creation" title="Site Creation" />
    <div class="container-fluid">
        <div class="email-wrap">
            <div class="row">
                <SiteList />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const SiteList = defineAsyncComponent(() => import("@/components/site-creation/site-list.vue"))
</script>